import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/hint.png'


const _withScopeId = n => (_pushScopeId("data-v-a66e0578"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "age-restricition-container"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "age-restricition" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "hint-icon"
}, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "form-wrapper"
}
const _hoisted_6 = { class: "hint-message" }
const _hoisted_7 = { class: "input-box" }
const _hoisted_8 = { class: "item" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "select-container" }
const _hoisted_11 = { class: "item" }
const _hoisted_12 = { class: "label" }
const _hoisted_13 = { class: "select-container" }
const _hoisted_14 = { class: "item" }
const _hoisted_15 = { class: "label" }
const _hoisted_16 = { class: "select-container" }
const _hoisted_17 = {
  key: 1,
  class: "form-wrapper"
}
const _hoisted_18 = { class: "hint-message" }
const _hoisted_19 = { class: "button-container" }

import { ref, reactive, onMounted, nextTick, inject } from 'vue';
  import dayjs from 'dayjs';
  import { IProgram } from '@/types/program';
  import { useRouter } from 'vue-router';
  import { useI18n } from 'vue-i18n';

  export interface IProps {
    program: IProgram
  }type Option = {
    value: Number,
    text: Number
  }

  
  const __default__ = {
    inheritAttrs: false,
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    program: null
  },
  setup(__props: any) {

const props = __props as {
    program: IProgram
  }

  ;

  const { t } = useI18n();
  const editorMode = inject<boolean>('editorMode');
  
  const router = useRouter();
  const ageVerified = ref(false); // 是否已验证
  const yearOptions = reactive<Option[]>([]);
  const monthOptions = reactive<Option[]>([]);
  const dayOptions = reactive<Option[]>([]);
  const form = reactive<{[propName: string]: number | null}>({
    year: dayjs().year(),
    month: dayjs().month() + 1,
    day: 1
  });
  async function updateDayOptions() {
    await nextTick();
    const len = dayjs(`${form.year}-${form.month}`).daysInMonth();
    dayOptions.splice(0, 31);
    for (let i = 0; i < len; i++) {
      dayOptions[i] = {
        value: i + 1,
        text: i + 1
      };
    }
    if (Number(len) < Number(form.day)) {
      form.day = null;
    }
  }

  function handleVerify() {
    const birthdate = [form.year, form.month, form.day].join('/');
    const age = dayjs().diff(birthdate, 'year');
    if (age >= Number(props.program?.age_restrictions?.age)) {
      handleVerifySuccess();
    } else {
      handleVerifyFail();
    }
  }

  function handleVerifyFail() {
    router.replace({ name: 'home' });
  }

  function handleVerifySuccess() {
    ageVerified.value = true;
  }

  onMounted(() => {
    form.year = dayjs().year();

    for (let i = 0; i < 12; i++) {
      monthOptions.push({
        value: i + 1,
        text: i + 1
      });
    }
    const year = dayjs().year();
    for (let i = 1900; i <= year; i++) {
      yearOptions.push({ value: i, text: i });
    }
    updateDayOptions();
  });

return (_ctx: any,_cache: any) => {
  const _component_b_form_select = _resolveComponent("b-form-select")!

  return (!_unref(editorMode) && __props.program?.age_restrictions?.age && (!ageVerified.value))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            (__props.program?.age_restrictions.must_enter_birthdate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(__props.program?.age_restrictions.message), 1),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('year')), 1),
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_b_form_select, {
                          modelValue: _unref(form).year,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).year) = $event)),
                          options: _unref(yearOptions),
                          onChange: updateDayOptions
                        }, null, 8, ["modelValue", "options"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(t)('month')), 1),
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_b_form_select, {
                          modelValue: _unref(form).month,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).month) = $event)),
                          options: _unref(monthOptions),
                          onChange: updateDayOptions
                        }, null, 8, ["modelValue", "options"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(t)('date')), 1),
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_b_form_select, {
                          modelValue: _unref(form).day,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).day) = $event)),
                          options: _unref(dayOptions),
                          disabled: !_unref(form).year || !_unref(form).month
                        }, null, 8, ["modelValue", "options", "disabled"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: "submit-btn",
                    onClick: handleVerify
                  }, _toDisplayString(_unref(t)('button_age_verification')), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, _toDisplayString(__props.program?.age_restrictions.message), 1),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", {
                      class: "btn",
                      onClick: handleVerifyFail
                    }, _toDisplayString(_unref(t)('no')), 1),
                    _createElementVNode("div", {
                      class: "btn",
                      onClick: handleVerifySuccess
                    }, _toDisplayString(_unref(t)('yes')), 1)
                  ])
                ]))
          ])
        ])
      ]))
    : _renderSlot(_ctx.$slots, "default", { key: 1 })
}
}

})